import { z } from "zod/v4-mini";

import { TandemEventDefinition } from "../TandemTypes";

export type G7CalibrationPayload = {
  value: number;
};

export type G7CalibrationEvent = {
  value: number;
};

const g7CalibrationSchema = z.object({
  value: z.number(),
});

export const LID_CGM_CALIBRATION_G7 = {
  value: 0x1b6,
  name: "CGM G7 Calibration",
  format: "s..............",
  fields: ["value"],
  postprocess: rec => rec,
  schema: g7CalibrationSchema,
} as const satisfies TandemEventDefinition<G7CalibrationPayload, G7CalibrationEvent>;
